/* Reviews page pagination: client-side paging over the review grid.
   Self-contained, scoped to [data-reviews-page-container]. */
(function () {
  function initPagination(container) {
    if (container.dataset.paginationInit === 'true') return;
    container.dataset.paginationInit = 'true';

    var grid = container.querySelector('[data-reviews-page-grid]');
    if (!grid) return;

    var pageSize = parseInt(container.dataset.reviewsPageSize, 10) || 12;
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-review-index]'));
    var total = items.length;
    if (total === 0) return;

    var totalPages = Math.max(1, Math.ceil(total / pageSize));
    var currentPage = 1;

    var pagination = container.querySelector('[data-reviews-pagination]');
    var prevBtn = container.querySelector('[data-reviews-page-prev]');
    var nextBtn = container.querySelector('[data-reviews-page-next]');
    var numbersWrap = container.querySelector('[data-reviews-page-numbers]');

    function renderNumbers() {
      if (!numbersWrap) return;
      numbersWrap.innerHTML = '';
      for (var p = 1; p <= totalPages; p++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'reviews-pagination__number' + (p === currentPage ? ' is-active' : '');
        btn.textContent = String(p);
        btn.setAttribute('aria-label', 'Page ' + p);
        btn.addEventListener('click', (function (pageNum) {
          return function () {
            goToPage(pageNum, true);
          };
        })(p));
        numbersWrap.appendChild(btn);
      }
    }

    function showPage(page) {
      items.forEach(function (item, idx) {
        var itemPage = Math.floor(idx / pageSize) + 1;
        item.style.display = itemPage === page ? '' : 'none';
      });
    }

    function goToPage(page, shouldScroll) {
      currentPage = Math.min(Math.max(1, page), totalPages);
      showPage(currentPage);
      renderNumbers();
      if (prevBtn) prevBtn.disabled = currentPage === 1;
      if (nextBtn) nextBtn.disabled = currentPage === totalPages;
      if (shouldScroll) {
        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToPage(currentPage - 1, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToPage(currentPage + 1, true);
      });
    }

    if (totalPages <= 1) {
      if (pagination) pagination.style.display = 'none';
    }

    goToPage(1, false);
  }

  function initAll() {
    var containers = document.querySelectorAll('[data-reviews-page-container]');
    for (var i = 0; i < containers.length; i++) {
      initPagination(containers[i]);
    }
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();